module.exports = __webpack_public_path__ + "assets/img/Cluey-Learning-1-Landing-Page-+-Website-w960.4640fae7.webp";